import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  storyBoardView: {
    display: 'flex',
    gap: '16px',
    height: '100%',
    minWidth: 'max-content',
    borderRadius: '10px',
    ...shorthands.padding(tokens.spacingVerticalMNudge),
    backgroundColor: '#FFFFFF',
  },
  templateContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '152px',
    backgroundColor: '#F0F0F0',
    borderRadius: '10px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  imageContainer: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 0,
  },
  templateThumbnail: {
    maxHeight: '100%',
    maxWidth: '100%',
    borderRadius: '10px',
    fontSize: '14px',
  },
  templateText: {
    color: tokens.colorNeutralForeground3,
    fontSize: '14px',
  },

  scenesContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    justifyContent: 'space-between',
  },

  sceneContainer: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: '8px',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'center',
  },

  sceneTitle: {
    fontSize: '16px',
    fontWeight: '500',
  },

  thumbnailsRow: {
    display: 'flex',
  },
  sceneItem: {
    '& .horizontal': {
      display: 'flex',
      marginTop: '5px',
      marginLeft: '5px',
      flexDirection: 'column',
      maxWidth: '125px',
      maxHeight: '71px', // 16x9 ratio
    },
    '& .vertical': {
      display: 'flex',
      marginTop: '5px',
      marginLeft: '5px',
      flexDirection: 'column',
      maxHeight: '125px',
      maxWidth: '71px', // 9x16 ratio
    },
    '& .scene-decorator': {
      borderRadius: '10px',
      '& .thumbnail': {
        overflow: 'hidden',
        '&.selected': {
          outlineColor: '#0078d4',
          outlineStyle: 'solid',
        },
        padding: 1,
      },
    },
  },
  sceneThumbnail: {
    borderRadius: '10px',
    marginBottom: '0px',
    padding: '0px',
  },
  sceneThumbnailImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  sceneNumber: {
    '& span': {
      verticalAlign: 'middle',
      lineHeight: '12px',
    },
  },
  audioBar: {
    display: 'flex',
    borderRadius: '10px',
    width: '100%',
    height: '28px',
    color: 'white',
    paddingTop: '2px',
    paddingLeft: '5px',
  },
  navigationContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});
